import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DialogModule} from '../../../../../common/dialog/dialog.module';
import {
    CreateUpdateDefaultModule
} from '../../../../../core/component/create-update-default/create-update-default.module';
import {CardModule} from '../../../../../core/component/card/card.module';
import {FormFieldModule} from '../../../../../core/component/form-field/form-field.module';
import {MedicalMorphologySaveDialogComponent} from './medical-morphology-save-dialog.component';
import {DatePickerModule} from '../../../../../../components/common/date-picker/date-picker.module';
import {NumberInputModule} from '../../../../../../components/common/number/number-input/number-input.module';
import {
    BmiSummaryFieldModule
} from '../../../../medical-record/general-information/api/component/bmi-summary-field/bmi-summary-field.module';
import {InputTextModule} from '../../../../../core/component/input-text/input-text.module';
import {LoadingModule} from '../../../../../../components/common/loading/loading.module';
import {ButtonModule} from '../../../../../core/component/button/button.module';
import {RichTextEditorModule} from '../../../../../../components/common/rich-text-editor/rich-text-editor.module';
import {CardV2Component} from "../../../../../core/component/card-v2/card-v2.component";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        FormsModule,
        ReactiveFormsModule,
        DialogModule,
        CreateUpdateDefaultModule,
        CardModule,
        FormFieldModule,
        DatePickerModule,
        NumberInputModule,
        BmiSummaryFieldModule,
        InputTextModule,
        LoadingModule,
        ButtonModule,
        RichTextEditorModule,
        CardV2Component,
    ],
    declarations: [
        MedicalMorphologySaveDialogComponent,
    ],
    exports: [
        MedicalMorphologySaveDialogComponent
    ],
})
export class MedicalMorphologySaveDialogModule {}
